import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import List from '../../components/List';
import ListItem from '../../components/ListItem';
import LoadingIndicator from '../../components/LoadingIndicator';
import NyheterListItem from '../../containers/NyheterListItem';
import NyheterListItemCard from '../../containers/NyheterListItemCard';
import Masonry from 'react-masonry-component';

const masonryOptions = {
  transitionDuration: 0,
};

const imagesLoadedOptions = { background: '.my-bg-image-el' };

const styles = theme => ({
  root: {
    flexGrow: 1,
    justifyContent: 'left',
  },
  control: {
    padding: theme.spacing(2),
  },
  griditem: {
    [theme.breakpoints.up('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },

    [theme.breakpoints.up('md')]: {
      width: '33%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '25%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
    [theme.breakpoints.up('xxl')]: {
      width: '16.5%',
    },
  },
  griditemhome: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },

    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '33%',
    },
  },
});
function NyheterList(props) {
  const {
    loading,
    error,
    nyheter,
    userid,
    user,
    masonryview,
    listview,
    favoriter,
  } = props;
  const { classes } = props;
  let homepage = false;
  let listclass = classes.griditem;

  if (props.home) {
    homepage = true;
    listclass = classes.griditemhome;
  }
  let limit = 0;
  let limitset = false;
  if(props.limit) {
    limit = props.limit;
    limitset =true;
  }
  if (error !== false && masonryview) {
    const ErrorComponent = () => (
      <ListItem item="Something went wrong, please try again!" />
    );
    return <List component={ErrorComponent} />;
  }

  if (nyheter !== false && masonryview) {
    return (
      <Masonry
        className="my-gallery-class" // default ''
        options={masonryOptions} // default {}
        columns={4} // default 2
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        imagesLoadedOptions={imagesLoadedOptions} // default {}
      >
        {nyheter.map((card, i) => {
          if(limitset && i >= limit) {
          } else {
            return(
              <Grid className={listclass} key={i} item xs={12}>
                <NyheterListItemCard
                  user={user}
                  userid={userid}
                  item={card}
                  key={i}
                  favoriter={favoriter}
                />
              </Grid>
            );
          }
          }
        )
      
        }
      </Masonry>
    );
  }
  if (nyheter !== false && listview) {
    return (
      <Grid
        container
        justifyContent="flex-start"
        className={classes.root}
        spacing={6}
      >
        {nyheter.map((card, i) => (
          <NyheterListItem user={user} userid={userid} item={card} key={i} favoriter={favoriter} />
        ))}
      </Grid>
    );
  }
  return null;
}

NyheterList.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.any,
  Nyheter: PropTypes.any,
};

export default withStyles(styles)(NyheterList);
